import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {EnumUtils, TranslateService, Unit} from '@vdw/angular-component-library';

@Component({
  selector: 'app-max-length-info-tooltip',
  templateUrl: './max-length-info-tooltip.component.html',
  styleUrls: ['./max-length-info-tooltip.component.scss']
})
export class MaxLengthInfoTooltipComponent {
  public buggyLengthMaxInPicks = 0;
  public buggyLengthMaxInCommercialUnit = 0;
  public lengthInBuggyInPicks = 0;
  public lengthInBuggyInCommercialUnit = 0;
  public commercialUnit = Unit.CENTIMETER;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly translate: TranslateService
  ) {
    this.buggyLengthMaxInPicks = data.buggyLengthMaxInPicks;
    this.buggyLengthMaxInCommercialUnit = data.buggyLengthMaxInCommercialUnit;
    this.lengthInBuggyInPicks = data.lengthInBuggyInPicks;
    this.lengthInBuggyInCommercialUnit = data.lengthInBuggyInCommercialUnit;
    this.commercialUnit = data.commercialUnit;
  }

  public getTotalBuggyLengthLabel(): string {
    return `${this.buggyLengthMaxInCommercialUnit} ${this.translate.instant(`GENERAL.UNIT.${EnumUtils.getKeyFromValue(Unit, this.commercialUnit)}`)} - ${this.buggyLengthMaxInPicks} ${this.translate.instant(
      `GENERAL.UNIT.${EnumUtils.getKeyFromValue(Unit, Unit.PICKS)}`
    )}`;
  }

  public getCurrentLengthInBuggyLabel(): string {
    return `${this.lengthInBuggyInCommercialUnit} ${this.translate.instant(`GENERAL.UNIT.${EnumUtils.getKeyFromValue(Unit, this.commercialUnit)}`)} - ${this.lengthInBuggyInPicks} ${this.translate.instant(
      `GENERAL.UNIT.${EnumUtils.getKeyFromValue(Unit, Unit.PICKS)}`
    )}`;
  }
}
